import { Fragment, useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __OPERATION__MANAGEMENT__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { NumeratorsCrumbs } from '../constants';
import { Numerator } from 'shell/models/numerator';
import { HttpResponse } from 'shell/models/http-response';
import FormNumerator, { NumeratorForm } from 'system/components/numerators/form';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const NumeratorEditPage = (): React.ReactElement => {
  const params = useParams();

  const { put: updateNumerator } = useHttpFetch(
    `${__OPERATION__MANAGEMENT__}/numeratore/documenti/${params.codiceEnte}/${params.tipoRegistro}/${params.annoDocumento}`
  );

  const navigate = useNavigate();

  const {
    data,
    get: getNumerator,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Numerator>>(
    `${__OPERATION__MANAGEMENT__}/numeratore/documenti/${params.codiceEnte}/${params.tipoRegistro}/${params.annoDocumento}`
  );

  const numeratorInitialValue: NumeratorForm = useMemo(() => {
    const numerator = data?.payload;
    if (!numerator || !!error) {
      return {
        numeratorRegisterType: '',
        year: '',
        description: '',
        currentNumerator: '',
      };
    }
    return {
      id: data?.payload.key.codiceEnte,
      numeratorRegisterType: data?.payload.key.tipoRegistro,
      year: data?.payload.key.annoDocumento.toString(),
      description: data?.payload.descrizioneNumeratore?.toString(),
      currentNumerator: data?.payload.progressivoDocumento?.toString(),
    } as unknown as NumeratorForm;
  }, [data, error]);

  const onSubmit = useCallback(
    (formValues: NumeratorForm | undefined) => {
      const payload: Numerator = {
        key: {
          codiceEnte: params.codiceEnte,
          tipoRegistro: params.tipoRegistro,
          annoDocumento: Number(params.annoDocumento),
        },
        descrizioneNumeratore: formValues?.description || '',
        progressivoDocumento: Number(formValues?.currentNumerator),
      };
      updateNumerator({
        ...payload,
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/numeratori');
      });
    },
    [updateNumerator, navigate]
  );

  useEffect(() => {
    getNumerator();
  }, []);

  return (
    <Fragment>
      <Breadcrumbs items={[...NumeratorsCrumbs, { name: 'Modifica Numeratore' }]} />
      {loading || !data || error ? null : (
        <FormNumerator
          title="Modifica Numeratore"
          onOk={(values) => {
            onSubmit(values);
          }}
          onCancel={() => {
            navigate('/sistema/numeratori');
          }}
          initialValues={numeratorInitialValue}
          // isEdit
        />
      )}
    </Fragment>
  );
};

NumeratorEditPage.displayName = 'Numerator Edit page component';

export default NumeratorEditPage;
